// Allowlisted organizations that can access DMS even when DK country block is active.
export const DMS_ALLOWED_ORGANIZATION_IDS = [
  'ZroTjrHbSJuKVSg5rAnfJQ',
  'WKv0dPFQQumfYSbf0V3qFQ',
  '00aeVX24Qk6JZxViAzLL2w',
  'MEAoC74yTOOE91P10ERZnA',
  'tkzPJ1BNRVae4rsigcvfKQ',
  'uBNFW5WVSpuxwvZ1uKExRg',
  'SF6SXvjURC2TXBWRCU3cSA',
  'gjkEyAbdTYTVpdVHpJU6bA',
  'IBruhNcTRNa0GFSIbu1txg',
  'lMONobhfTDuKJ2MijQoX1g',
  'urx5diL3RVWu2GUyjxywvw',
]
export const DMS_ALLOWED_UMBRELLA_IDS = ['91a393ad-491e-44ba-94ac-d9d5e9d118f3', 'cf80f7d9-ad3a-4464-a1ca-db6a822fa60e']
